/**
 * SEO
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/seo',
  name: 'SEO管理',
  component: Layout,
  children: [
    {
      path: 'attrs',
      name: '聚合页维护',
      component: () => import('@/views/seo/attrs/index.vue')
    }
  ],
}